import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { api } from '../../api';
import { t, tx } from '../../i18n';
import { fmtDate, fmtKB } from '../../lib/format';
import { eur, eurS } from '../../lib/money';
import { useApi } from '../../lib/useApi';
import { Preview } from '../belege/BelegSheet';
import { Sheet } from '../belege/Sheet';
import { useCloseSheet } from '../lohn/Pages';
import type { BwaDetail } from './types';
import { ShareFile } from '../../components/ShareFile';

// Eine BWA (?bwa=<id>): Vorschau der Datei, Summe seit Januar und Herunterladen
export function BwaSheetHost() {
  const [params] = useSearchParams();
  const close = useCloseSheet('bwa');
  const id = params.get('bwa');
  return id ? <BwaSheet key={id} id={id} onClose={close} /> : null;
}

function BwaSheet({ id, onClose }: { id: string; onClose(): void }) {
  const res = useApi<BwaDetail>(`/api/app/bwa/${id}`, { live: ['guv'] });
  const b = res.data;

  // Meldung dazu gilt als gelesen, sobald das Fenster die BWA zeigt
  const loaded = !!b;
  useEffect(() => {
    if (loaded) api.post(`/api/app/bwa/${id}/read`).catch(() => {});
  }, [id, loaded]);

  if (!b) {
    return (
      <Sheet title="BWA" onClose={onClose}>
        {res.error ? <p className="meta">{res.error}</p> : <div className="spinner" aria-label={t('Lädt')} />}
      </Sheet>
    );
  }

  const url = `/api/app/bwa/${b.id}/file`;
  return (
    <Sheet title={tx(b.title)} onClose={onClose}>
      <div className="meta">
        {b.clientName} · {t('hochgeladen von Ihrer Kanzlei am {date}', { date: fmtDate(b.uploadedAt) })}
      </div>
      <Preview url={url} mime={b.file.mime} name={b.file.name} />
      <dl className="akte ptbl">
        <div>
          <dt>{t('Zeitraum')}</dt>
          <dd>{tx(b.period)}</dd>
        </div>
        <div>
          <dt>{t('Umsatz')}</dt>
          <dd>{eur(b.sum.revenue)}</dd>
        </div>
        <div>
          <dt>{t('Ausgaben')}</dt>
          <dd>{eur(b.sum.costs)}</dd>
        </div>
        <div>
          <dt>{t('Ergebnis')}</dt>
          <dd>
            <b>{eurS(b.sum.result)}</b>
          </dd>
        </div>
      </dl>
      <div className="row">
        <a className="btn2 dark" href={`${url}?download=1`} download>
          {b.file.mime === 'application/pdf' ? t('PDF herunterladen') : t('Bild herunterladen')}
        </a>
        <ShareFile url={`${url}?download=1`} name={b.file.name} />
      </div>
      <p className="src">
        {b.file.name} · {fmtKB(b.file.size)}
      </p>
    </Sheet>
  );
}
